// IndexedDB setup for offline-first storage
import { get, set, del, keys, clear } from 'idb-keyval';

// Generic typed wrappers
export async function getItem<T>(key: string): Promise<T | undefined> {
  return get<T>(key);
}

export async function setItem<T>(key: string, value: T): Promise<void> {
  return set(key, value);
}

export async function removeItem(key: string): Promise<void> {
  return del(key);
}

export async function getAllKeys(): Promise<IDBValidKey[]> {
  return keys();
}

export async function clearAll(): Promise<void> {
  return clear();
}
